import { createSelector } from 'reselect'
import { fromJS } from 'immutable'
import { getSlideMedia} from '../../lib/mediaUtil';

const getCollection = state => state.collection
const getApp = state => state.app

const getCollectionBackgroundColour = acf => (
  acf ? acf.get('background_colour') : '#f3f1ed'
)

export const getCollectionColours = createSelector(
  [getCollection],
  collection => {
    const data = collection.get('data')
    if (data) {
      const baseColour = {
        id: 'base',
        colour: getCollectionBackgroundColour(data.get('acf'))
      }

      const acf = data.get('acf')
      if (!acf) return fromJS([ baseColour ])

      const slides = acf.get('slide')
      // hide first slide as this is the 'teaser' slide
      const trimmedSlides = slides.size > 1 ? slides.slice(1) : slides

      const colours = trimmedSlides.map((slide, index) => ({
        id: index,
        colour: slide.get('slide_background_colour')
      }))

      return colours.insert(0, baseColour)

    } else return null
  }
)

const getCollectionSlides = data => {
  if (!data) return null

   // get ACF fields
  const acf = data.get('acf')
  if (!acf) return null

  // rows are slides for collections
  const slides = acf.get('slide')

  // hide first slide as this is the 'teaser' slide
  const trimmedSlides = slides.size > 1 ? slides.slice(1) : slides

  return trimmedSlides.map(getCollectionItem)
}

export const getCollectionArtistSlug = createSelector(
  [getCollection],
  collection => {
    const data = collection.get('data')
    if (data) {
      const acf = data.get('acf')
      const artistNameField = acf && acf.get('artist_name')
      return artistNameField && artistNameField.get('post_name')
    } else return null
  }
)

const getCollectionItem = (slide, index) => {
  return {
    id: index + parseInt(Math.random() * 100000, 10),
    slide: slide,
    isSpreadMargin: slide && slide.get('spread_margin')
  }
}

export const getCollectionFetching = createSelector(
  [getCollection],
  collection => collection.get('fetching')
)

export const getCollectionSubtitle = createSelector(
  [getCollection],
  collection => {
    const data = collection.get('data')
    if (data) {
      return data.get('title') ? data.getIn(['title', 'rendered']) : ''
    } else return null
  }
)

export const getCollectionTitle = createSelector(
  [getCollection],
  collection => {
    const data = collection.get('data')
    if (data) {
      const acf = data.get('acf')
      const artistNameField = acf && acf.get('artist_name')
      return artistNameField && artistNameField.get('post_title')
    } else return null
  }
)

export const getCollectionRows = createSelector(
  [getCollection],
  collection => {
    const data = collection.get('data')

    return data ? getCollectionSlides(data) : null
  }
)

const getAllImages = rows => {
  return rows
    .reduce((prev, curr) => {
      // Media list
      // row.get('slide_media)
      const media = curr.slide.get('slide_media')

      // Flatten for list of all images
      prev = prev.concat(media.reduce((p, c) => {
        p = p.concat(c)
        return p
      }, []))

      return prev
    }, [])
}
  

const getLightboxSlides = (allImages, vw) => {
  return allImages.map((slide, index) => {
    const mediaWidth = Math.max(480, slide.get('width') * vw / 24)
    const media = getSlideMedia(slide, mediaWidth)
    return {
      id: index,
      index,
      type: slide.get('media'),
      mediaSubType: media.type,
      media,
    }
  })
}

export const getCollectionLightboxSlides = createSelector(
  [getCollection, getApp],
  (collection, app) => {
    const data = collection.get('data')
    const slides = data ? getCollectionSlides(data) : null
    const allImages = slides ? getAllImages(slides) : null
    const lightboxSlides = allImages ? getLightboxSlides(allImages, app.get('vw')) : null

    return lightboxSlides
  }
)

export const getCollectionRequestId = createSelector(
  [getCollection],
  collection => {
    return collection.get('requestId')
  }
)



// WEBPACK FOOTER //
// ./src/components/collection-container/selectors.js